import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/absence",
      name: "absence",
      meta: {
        requiresAuth: true,
        title: "routes.absence"
      },
      component: () => import("./main.vue")
    }
  ]
};
